export const getPreviousMonth = (date: string) => {
  const _date = new Date(date);
  const monthId = _date.getMonth();
  const previousMonth = monthId < 10 ? `0${monthId}` : String(monthId);
  const isFirstMonthOfYear = monthId === 0;
  const year = new Date(date).getFullYear();

  if (isFirstMonthOfYear) {
    return `${year - 1}-12-01`;
  } else {
    return `${year}-${previousMonth}-01`;
  }
};
